import React, { PureComponent } from 'react';
import styles from './index.css';
import { h5PageCount } from '../../../utils';
import { setlocal, getlocal } from '../../../base/base/storage';
import { callApp, getSchemeLink, getWebAppLink } from '@ifeng/callapp';
import { WxLaunchApp } from '../../wxLaunchApp';
class WXGuideLayer extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isShowLayer: false
        };
        this.pageLoadCount = 1;
        this.initLayer = () => {
            const userAgentStr = (typeof navigator === 'object' && navigator.userAgent && navigator.userAgent.toLocaleLowerCase()) || '';
            const theSameDay = getlocal('theSameDay');
            const pageLoadCount = getlocal('pageLoadCount');
            const liveDataTime = this.getDataTime().formatYear;
            const { wxConfig: { continueBtnSet = 0, endTime = '23:59:59', leaveSet = 0, openSet = 0, startTime = '00:00:00', wxGuideLayerArticle = [], }, wxConfig, base62Id } = this.props;
            const actionVal = getlocal('action');
            const startTimeStamp = new Date(`${liveDataTime} ${startTime}`).getTime();
            const endTimeStamp = new Date(`${liveDataTime} ${endTime}`).getTime();
            const liveTimeStamp = new Date().getTime();
            const allArticleId = [];
            wxGuideLayerArticle.forEach((item) => {
                if (item.id) {
                    allArticleId.push(item.id);
                }
            });
            if (theSameDay &&
                theSameDay === liveDataTime &&
                pageLoadCount &&
                ((actionVal === 'continue' &&
                    continueBtnSet &&
                    pageLoadCount > continueBtnSet) ||
                    (actionVal === 'open' &&
                        openSet &&
                        pageLoadCount > openSet) ||
                    (actionVal === 'leave' &&
                        leaveSet &&
                        pageLoadCount > leaveSet) ||
                    (liveTimeStamp <= startTimeStamp) ||
                    (liveTimeStamp >= endTimeStamp))) {
                return false;
            }
            if (userAgentStr.indexOf('micromessenger') !== -1 &&
                (wxConfig.switch === '1' || allArticleId.includes(base62Id))) {
                this.setState({
                    isShowLayer: true
                });
                document.body.style.position = 'fixed';
                document.body.style.top = '0';
            }
            return true;
        };
        this.initLoadCount = () => {
            const theSameDay = getlocal('theSameDay');
            const liveDataTime = this.getDataTime().formatYear;
            // 当天是否首次进入
            if (theSameDay !== liveDataTime) {
                setlocal('theSameDay', liveDataTime);
                setlocal('action', '');
                setlocal('pageLoadCount', 1);
            }
            else {
                if (!getlocal('action')) {
                    setlocal('action', 'leave');
                }
                this.pageLoadCount = getlocal('pageLoadCount') || 0;
                this.pageLoadCount++;
                setlocal('pageLoadCount', this.pageLoadCount);
            }
        };
        this.getDataTime = () => {
            const myDate = new Date();
            const year = myDate.getFullYear();
            const month = myDate.getMonth() + 1;
            const day = myDate.getDate();
            const hours = myDate.getHours();
            const minutes = myDate.getMinutes();
            const seconds = myDate.getSeconds();
            return {
                formatTime: `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`,
                formatYear: `${year}/${month}/${day}`
            };
        };
        this.handleCallApp = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
            const { callAppConfig, clickCallAppConfig } = this.props;
            if (!getlocal('action')) {
                setlocal('action', 'open');
            }
            if (clickCallAppConfig && isSendCount) {
                h5PageCount([clickCallAppConfig]);
            }
            if (clickCallAppConfig && isJumpQQlink) {
                clickCallAppConfig.other.tag = 't9';
                h5PageCount([clickCallAppConfig]);
            }
            if (callAppConfig && isCallApp) {
                callAppConfig.isCopySchemeUrl = isJumpQQlink;
                callApp(callAppConfig);
            }
        };
        this.closeLayer = () => {
            const { clickContinueConfig } = this.props;
            if (!getlocal('action')) {
                setlocal('action', 'continue');
            }
            this.setState({
                isShowLayer: false
            });
            if (clickContinueConfig) {
                // 关闭统计
                h5PageCount([clickContinueConfig]);
            }
            document.body.style.position = '';
            document.body.style.top = '';
        };
    }
    componentDidMount() {
        this.initLoadCount();
        this.initLayer();
    }
    render() {
        const { isShowLayer } = this.state;
        const { wxLaunchType, wxLaunchSwitch, callAppConfig } = this.props;
        const schemeLink = wxLaunchType === 'weapp' ?
            getWebAppLink(callAppConfig) : getSchemeLink(callAppConfig);
        return (isShowLayer && React.createElement("div", { className: styles.guideLayer },
            React.createElement("div", { className: styles.guideMenu },
                React.createElement("div", { className: styles.guideMenuItem },
                    React.createElement("img", { className: styles.guideMenuIcon, src: "https://x0.ifengimg.com/ucms/2020_47/72D5F2C83657D87D6027573A0E523497387BBC5E_w144_h144.png" }),
                    React.createElement("div", { className: styles.guideMenuInfo },
                        React.createElement("h2", { className: styles.guideMenuName }, "\u51E4\u51F0\u65B0\u95FB"),
                        React.createElement("p", { className: styles.guideMenuBref }, "\u5168\u7403\u70ED\u70B9\u4E00\u7F51\u6253\u5C3D")),
                    React.createElement("div", { className: styles.guideMenuButton },
                        React.createElement("img", { onClick: this.handleCallApp.bind(this, true, false, true), src: "https://x0.ifengimg.com/ucms/2020_47/25F9C4EBDD935FBE7F2D606CEF7D6310DA5F9FCC_w228_h96.png" }),
                        wxLaunchSwitch && React.createElement(WxLaunchApp, { launchType: wxLaunchType, schemeLink: schemeLink, launchAppClick: this.handleCallApp.bind(this, true, false, false), launchAppFail: this.handleCallApp.bind(this, false, true, true) }))),
                React.createElement("div", { className: styles.guideMenuItem },
                    React.createElement("div", { className: styles.guideMenuText }, "\u7EE7\u7EED\u6D4F\u89C8\u7CBE\u5F69\u5185\u5BB9"),
                    React.createElement("div", { className: styles.guideMenuButton },
                        React.createElement("img", { onClick: this.closeLayer, src: "https://x0.ifengimg.com/ucms/2020_47/1A9CA5465B6A964119B212FF0C02D37460038204_w228_h96.png" }))))));
    }
}
export default WXGuideLayer;
